import {
    select,
    take,
    fork,
    put,
    all,
    call,
    takeEvery,
  } from 'redux-saga/effects'
  
  import {
    updateTablesAction,
  } from 'containers/Entity/actions'
  
  import {
    get,
    getEntityData
  } from 'helpers/RequestUtil'
  
  import {
    FETCH_PROJECT_LIST,
    FETCH_PROJECT_SPEC,
  } from './constants'
  
  import * as R from 'ramda'

  import {
    fetchProjectSpecStart,
    fetchProjectSpecSuccess,
    fetchProjectSpecError,
    setImportDialogDone,
    setImportDialogError,
    setProjectList,
    fetchProjectListStart,
    fetchProjectListSuccess,
    fetchProjectListError,
  } from './actions'

  import {
    loadRevision,
    copyFormElements
  } from 'containers/Form/actions'

  import {
    elementsEntitySelector
  } from 'containers/Form/selectors'
  
  import {
    LOAD_REVISION_SUCCESS,
    LOAD_REVISION_ERROR
  } from 'containers/Form/constants'
  
  import {
    buildUrl,
  } from 'helpers/actionHelper'

  import {
    getElements
  } from 'containers/Form/sagas'
  
  function* fetchProjectList(query) {
    if (query === '') return
    try {
      yield put(fetchProjectListStart())
      const params = [{ type: 'search_dropdown', value: query }]
      const url = buildUrl('/api/fulcrum/project/lists', ...params)
      const data = yield call(get, url)
      const { entities: { lists: list } } = data
      yield put(updateTablesAction(data))
      yield put(fetchProjectListSuccess())
      return list
    } catch(error) {
      yield put(fetchProjectListError(error))
    }
  }
  
  function* fetchProjectSpec(projectId) {
    try {
      yield put(fetchProjectSpecStart())
      const url = buildUrl(`/api/fulcrum/projects/${projectId}/revisions`)
      const data = yield call(get, url)
      yield put(fetchProjectSpecSuccess())
      const { entities: { revisions: list } } = data
      return list
    } catch(error) {
      yield put(fetchProjectSpecError(error))
      return false
    }
  }

  function* handleFetchProjectList({ query }) {
    const projectList = yield call(fetchProjectList, query)
    yield put(setProjectList(projectList ? projectList : []))
  }

  function* handleFetchProjectSpec({ projectId }) {
    const result = yield call(fetchProjectSpec, projectId)
    if (!result) {
      yield put(setImportDialogError())
      return
    }
    const { data : latestRevisionData } = yield Object.values(result).reduce(function(prev, current) {
      return (prev && prev.id > current.id) ? prev : current
    })

    const elementEntities = yield select(elementsEntitySelector)
    const elements = yield getElements(latestRevisionData, R.values(elementEntities))
    yield put(copyFormElements(R.clone(elements)))
    yield put(setImportDialogDone())
  }
  
  function* watchFetchProjectList() {
    yield takeEvery(FETCH_PROJECT_LIST, handleFetchProjectList)
  }
  
  function* watchFetchProjectSpec() {
    yield takeEvery(FETCH_PROJECT_SPEC, handleFetchProjectSpec)
  }
  
  function* loadSagas() {
    yield all([
      fork(watchFetchProjectList),
      fork(watchFetchProjectSpec)
    ])
  }
  
  export default loadSagas
  